export default __webpack_public_path__ + "static/media/hero-image-1-new.8e9cbde3.png";